import { Component, h, Prop } from "@stencil/core";
import { TranslateService } from "../../../services";

@Component({
  tag: "av-pointer",
  styleUrl: "av-pointer.scss",
  shadow: true,
})
export class AvPointer {
  @Prop() left: number;
  @Prop() top: number;
  @Prop() sender: string;

  render() {
    return (
      <div
        aria-label={TranslateService.instant("Co-browse pointer")}
        class="av-pointer"
        style={{ transform: `translate(${this.left}px, ${this.top}px)` }}
      >
        <span class="av-pointer-sender">{this.sender}</span>
      </div>
    );
  }
}
